/* @flow */

import qs from 'qs';
import { obrigatorio } from './utils';

import { type Filtro as FiltroType, type TipoOpcao, type ValoresFormulario } from './types';

export const TipoOpcaoEnum: {
    [string]: TipoOpcao,
} = {
    string: 'string',
    number: 'number',
};

export default class Filtro {
    form: HTMLFormElement;

    quantidade: ?HTMLSelectElement;

    coluna: ?HTMLSelectElement;

    opcao: ?HTMLSelectElement;

    valor: ?HTMLInputElement;

    constructor(form: HTMLFormElement = obrigatorio()) {
        this.form = form;
        const quantidade = form.elements.namedItem('quantidade');
        const coluna = form.elements.namedItem('coluna');
        const opcao = form.elements.namedItem('opcao');
        const valor = form.elements.namedItem('valor');

        if (quantidade instanceof HTMLSelectElement) {
            this.quantidade = quantidade;
        }


        if (coluna instanceof HTMLSelectElement) {
            this.coluna = coluna;
            this.setEventoAlteraOpcao(this.coluna);
        }

        if (opcao instanceof HTMLSelectElement) {
            this.opcao = opcao;
        }

        if (valor instanceof HTMLInputElement) {
            this.valor = valor;
        }
    }

    getFiltro(): FiltroType | null {
        const valor = this.valor ? this.valor.value : null;
        const opcao = this.opcao ? this.opcao.value : null;
        const coluna = this.coluna ? this.coluna.value : null;
        if (!valor) {
            return null;
        }
        return { valor, opcao, coluna };
    }

    getQuantidade(): number | null {
        if (!this.quantidade) {
            return null;
        }
        return Number(this.quantidade.value) || 10;
    }

    setEventoAlteraOpcao(select: HTMLSelectElement) {
        select.onchange = () => {
            const { dataset } = select.options[select.selectedIndex];
            const tipo = TipoOpcaoEnum[dataset.tipo];
            this.alterarOpcao(tipo);
            this.alterarTypeInput(tipo);
        };
    }

    /**
     * Altera os <option> do campo opcões de acordo como data-tipo do <select name="coluna">
     * @param  {String} tipo
     */
    alterarOpcao(tipo: TipoOpcao) {
        if (!this.opcao) {
            return;
        }
        const options = Array.from(this.opcao.options);
        options.forEach((option) => {
            const display = option.dataset.tipo === tipo
                ? 'block'
                : 'none';

            option.style.display = display;
        });

        this.selecionarPrimeiroOptionValorVisivel();
    }

    /**
     * seleciona o primeiro <option> do <select name="opcao"> com display: block
     */
    selecionarPrimeiroOptionValorVisivel() {
        if (!this.opcao) {
            return;
        }

        Array.from(this.opcao.options).every((option) => {
            if (option.style.display === 'block') {
                option.selected = true;
                return false;
            }
            return true;
        });
    }

    /**
     * Altera os <input> do campo valor de acordo como data-tipo do <select name="coluna">
     * @param  {String} tipo
     */
    alterarTypeInput(tipo: TipoOpcao) {
        if (!this.valor) {
            return;
        }

        if (tipo === 'number') {
            this.valor.type = 'number';
        } else if (tipo === 'string') {
            this.valor.type = 'search';
        }
    }

    /**
     * Seta os valores do objeto no formulario de acordo com as chaves
     * @param  {Object} obj
     */
    setValoresQuery() {
        const { quantidade, filtro }: ValoresFormulario = qs.parse(
            global.location.search.substr(1),
        );

        if (quantidade) {
            const selectQuantidade = this.quantidade;
            if (selectQuantidade) {
                selectQuantidade.value = String(quantidade);
            }
        }

        if (filtro && filtro.valor) {
            if (this.valor) {
                this.valor.value = filtro.valor;
            }

            if (this.coluna) {
                this.coluna.value = filtro.coluna || '';
            }

            if (this.opcao) {
                this.opcao.value = filtro.opcao || '';
            }
        }
    }
}
